import styled from "styled-components";
import Grid from "@material-ui/core/Grid/Grid";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";

export const DesktopWrapper = styled.div`
    height: 100%;
`;

export const GridContainer = styled(Grid)`
    height: calc(100% - 64px);
`;

export const MapWrapper = styled(Grid)`
    height: 100%;
`;

export const ThreeGridWrapper = styled(Grid)`
    height: 50%;
`;

export const InfoWrapper = styled(Grid)`
    height: 50%;
    overflow: auto; 
`;

export const InfoAndThreeWrapper = styled(Grid)`
    height: 100%;
`;

export const GenerateProgress = styled(LinearProgress)`
    position: absolute !important;
    width: 100%;
    top: 0;
    left: 0;
`;



// WEBPACK FOOTER //
// ./src/desktop/Desktop.sc.js